import { gql } from "lib/apolloClient";
import {
  studentFragment,
  pypElementRatingFragment,
  staffFragment,
  genericTagFragment,
} from "modules/CommonFragments";
import { studentInfofragment } from "StudentPortfolio/routes/PortfolioDetailsV2/modules/ProfileDetailsFragments";
import { otherDetailsFragment } from "StudentProfileCommon/modules/StudentProfileFragments";

// Local student fragment for StudentPortfolio
const studentPortfolioFragment = {
  studentBasicDetails: gql`
    fragment studentItem on Student {
      id
      firstName
      middleName
      lastName
      pronouns
      preferredName
      prefix
      suffix
      profileImage
      email
      type
      isDevUser
      isArchived
      sourceId
    }
  `,
};

export const courseStudentFragment = {
  courseStudent: gql`
    fragment courseItem on Course {
      id
      students(
        after: $after
        filters: $filters
        orderBy: $orderBy
        orderByDirection: $orderByDirection
      ) {
        edges {
          node {
            courseMap(filters: { courseIds: [$id] }) {
              id
              tags {
                id
                label
                type
              }
            }
            ...studentItem
            isArchivedV2(filters: $userArchivedFilters)
          }
        }
      }
    }
    ${studentFragment.basicStudentDetails}
  `,
  courseStudentBasicDetails: gql`
    fragment courseItem on Course {
      id
      organization {
        id
        name
      }
      students(
        after: $after
        filters: $filters
        orderBy: TITLE
        orderByDirection: ASC
      ) {
        edges {
          node {
            ...studentItem
          }
        }
      }
    }
    ${studentFragment.basicStudentDetails}
  `,
  courseStudentWithInviteCode: gql`
    fragment courseItem on Course {
      id
      organization {
        name
      }
      students(
        after: $after
        filters: $filters
        orderBy: TITLE
        orderByDirection: ASC
      ) {
        edges {
          node {
            ...studentItem
            familyInviteCode
            signInCode
          }
        }
      }
    }
    ${studentFragment.basicStudentDetails}
  `,
  courseStudentPortfolio: gql`
    fragment courseItem on Course {
      id
      students(
        after: $after
        filters: $filters
        orderBy: $orderBy
        orderByDirection: $orderByDirection
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
        allCount
        archivedCount
        blockedCount
        edges {
          node {
            ...studentItem
            ...studentAdditionalInfoItem
            isArchivedV2(filters: { academicYearId: $academicYearId })
            allGrades {
              id
              name
            }
            registrationCategory
            gender
            otherDetails {
              ...otherDetailsItem
            }
            yearGroup {
              id
              name
              grade {
                id
                name
              }
            }
            allPosts(filters: $postFilters) {
              totalCount
            }
            familyInviteCode
            signInCode
            staffRelation(filters: $staffRelationFilters) {
              edges {
                node {
                  ... on Staff {
                    id
                    profileImage
                    firstName
                    middleName
                    lastName
                    preferredName
                    prefix
                    suffix
                    pronouns
                    isArchived
                    isArchivedV2(filters: { academicYearId: $academicYearId })
                    type
                  }
                }
              }
            }
            families {
              id
              status
              familyMember {
                id
                lastName
                middleName
                firstName
                preferredName
                prefix
                suffix
                pronouns
                type
                profileImage
              }
              createdAt
            }
            courseMap(filters: $courseMapFilters) {
              id
              tags {
                ...basicGenericTagItem
                reportDisplayName
              }
              subjectWiseLevel {
                subject {
                  id
                }
                level {
                  id
                  abbreviation
                  label
                  reportDisplayName
                }
              }
            }
          }
        }
      }
      totalStudentsCountWithoutSearch: students(
        filters: $filtersWithoutSearch
      ) {
        totalCount
      }
    }
    ${studentPortfolioFragment.studentBasicDetails}
    ${studentInfofragment.additionalInfo}
    ${genericTagFragment.genericTag}
    ${otherDetailsFragment.otherDetails}
  `,
};

export const pypElementRemarkFragment = {
  studentElementRemark: gql`
    fragment remarkItem on IbPypElementRemark {
      id
      ibPYPElementId
      ibPYPElementType
      message
      createdBy {
        ...staffItem
      }
      updatedAt
      parentType
      parent {
        id
        ... on StudentProgressReport {
          courseProgressReportTask {
            id
            progressReportTaskGroup {
              id
              title
            }
          }
        }
      }
    }
    ${staffFragment.basicStaffDetails}
  `,
};

export const studentPypEvaluationFragment = {
  studentPypElementRatings: gql`
    fragment studentPypEvaluationItem on Student {
      id
      ibPYPElementRatings(
        filtersForRecentMost: $filtersForRecentMost
        startDate: $startDate
        endDate: $endDate
        dataSet: MOST_RECENT
      ) {
        ...ratingItem
      }
    }
    ${pypElementRatingFragment.studentElementRating}
  `,
  studentPypElementRemarks: gql`
    fragment studentPypEvaluationItem on Student {
      id
      ibPypElementRemarks(elementTypes: $elementTypes) {
        ...remarkItem
      }
    }
    ${pypElementRemarkFragment.studentElementRemark}
  `,
};
